<template>
	<!--限定数量残無しメッセージ、当日残無しメッセージの表示-->
	<div id="limitMsgShow" class="limitMsgShow sort-item" v-if="ptInitData.productInfo.NO_LIMIT_FLG == 1">
		<dl class="text-danger">
			<dd>
				{{ ptInitData.productInfo.NO_LIMIT_MSG }}
			</dd>
		</dl>
	</div>
</template>
<script>
	export default {
		methods: {
		},
		name: 'limitMsgShow',
		props: {
			ptInitData: {
				type: Object,
				default: null
			}
		}
	}
</script>